






























import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import AssignAreeDataTable from "../../components/DataTables/AssignAreeDataTable.vue";
import { AreaInfo } from "../../_models/areaInfo";

@Component({
  components: {
    CardTitle,
    AssignAreeDataTable
  }
})
export default class AssegnazioneAreeAllievi extends Vue {
  private dataTableParams: any;
  private titleParams: object;
  private createDialogParams: object;
  private listaAssegnazioniAree: any;
  private listaAree: any;

  private changed: boolean;
  private userInfo: any;
  private errorOccured: boolean;

  constructor() {
    super();
    this.titleParams = {
      title: "ASSEGNAZIONE AREE ALLIEVI",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allieva/o",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Settore",
          value: "nomeArticolazione"
        },
        {
          text: "Comune Residenza",
          value: "residenza"
        },
        {
          text: "Area",
          value: "areaSelect",
          width: "30%"
        },
        {
          text: "Cancella Assegnazione",
          value: "deleteAssegnazioneAllievoArea"
        }
      ],
      records: [],
      filterType: "",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ],
      listaAree: [
        {
          idArea: "Tutte",
          descrizioneArea: "Tutte"
        }
      ],
      type: "assegnazioneAree"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaAssegnazioniAree = [];
    this.listaAree = [];
    this.userInfo = null;
    this.changed = false;
    this.errorOccured = false;
  }

  loadAssegnazioniAree() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchAssegnazioniAreeAllievi(this["$store"], payload)
      .then(result => {
        this.listaAssegnazioniAree = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoadedAssegnazioni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  // loadAree() {
  //   var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
  //   var payload = {
  //     idIstituto: instituteInfo.id
  //   };
  //   data
  //     .dispatchAreeIstituto(this["$store"], payload)
  //     .then(result => {
  //       this.listaAree = result;
  //       result.forEach(element => {
  //         this.dataTableParams.listaAree.push({
  //           idArea: element.idArea,
  //           descrizioneArea: element.descrizioneArea
  //         });
  //       });
  //     })
  //     .catch(error => {
  //       if (error.response.status === 403) {
  //         bus.$emit("errorOperation", error.response.statusText);
  //         this["$router"].push("/login");
  //       } else {
  //         bus.$emit("errorOperation", error.response.statusText);
  //       }
  //     });
  // }

  loadAree(idIstituto: number, idArticolazione: string) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idIstituto: idIstituto
    };
    data
      .dispatchAreeIstituto(this["$store"], payload)
      .then(resp => {
        resp.forEach(element => {
          var area: AreaInfo;
          var payload3 = {
            idArea: 0,
            idArticolazione: idArticolazione,
            idAnnoScolastico: idAnnoScolastico
          };
          area = {
            idArea: element.idArea,
            descrizioneArea: element.descrizioneArea,
            studentiArea: [],
            aziendeArea: [],
            nMinTurni: 0,
            nIdealTurni: 0
          };
          area.idArea = element.idArea;
          area.descrizioneArea = element.descrizioneArea;
          payload3.idArea = element.idArea;

          data
            .dispacthAllieviArea(this["$store"], payload3)
            .then(risp => {
              area.studentiArea = risp;
              data
                .dispatchAziendeArea(this["$store"], payload3)
                .then(res => {
                  area.aziendeArea = res;
                  this.listaAree.push(area);
                  this.dataTableParams.listaAree.push({
                    idArea: element.idArea,
                    descrizioneArea: element.descrizioneArea
                  });
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", error.response.statusText);
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", error.response.statusText);
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  save() {
    bus.$emit("saveAssegnazioniAreaAllievi");
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    this.dataTableParams.records.forEach((element: any) => {
      var payload = {
        idIscrizione: element.idIscrizioneAttivita,
        idArea: element.idArea
      };
      user
        .dispatchSaveAssegnazioneAreaAllievo(this["$store"], payload)
        .then(() => {})
        .catch(error => {
          this.errorOccured = true;
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    });
    if (this.errorOccured === true) {
      this.errorOccured = false;
      bus.$emit(
        "errorOperation",
        "Si sono verificati alcuni errori nel salvataggio di uno o più assegnazioni. Rieseguire il salvataggio"
      );
    } else {
      this.listaAree = [];
      this.loadAree(instituteInfo.id, "");
      bus.$emit("successfullOperation", "Assegnazioni salvate con successo");
      this.changed = false;
    }
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        this.userInfo = user.readUserInfo(this["$store"]);
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(response => {
                response.forEach(element => {
                  this.dataTableParams.listaArticolazioni.push(element);
                });
                this.loadAree(instituteInfo.id, "");
                this.loadAssegnazioniAree();
              });
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("filtroAssegnazioneAree", (filters: any) => {
      const listaAssegnazioniAree: any = this.listaAssegnazioniAree;
      var tempList: any = [];
      var tempList2: any = [];
      this.dataTableParams.records = [];
      listaAssegnazioniAree.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList.push(item);
            }
          }
        } else {
          tempList.push(item);
        }
      });
      tempList.forEach((item: any) => {
        if (filters.filtroArea !== "Tutte") {
          if (item.idArea === filters.filtroArea) {
            tempList2.push(item);
          }
        } else {
          tempList2.push(item);
        }
      });
      this.dataTableParams.records = tempList2;
    });

    bus.$on("assegnazioneAreeChanged", () => {
      this.changed = true;
    });

    bus.$on("loadAssegnazioniAllieviAree", () => {
      var instituteInfo = user.readInstituteInfo(this["$store"]);
      this.listaAree = [];
      this.loadAree(instituteInfo.id, "");
      this.loadAssegnazioniAree();
    });
  }
}
